<template>
    <div class="p-0 flex-grow-1 text-dark-50 py-2 py-lg-2 mb-5">
        <div class="py-2">
            <div
                v-for="prize in presentation.author_credentials.prizes_and_grants"
                :key="'prize-' + prize"
            >
                <span class="mr-2">
                    <span class="svg-icon svg-icon-success">
                        <CrownSvg />
                    </span>
                </span>
                {{ prize }}
            </div>
        </div>
    </div>
</template>

<script>
import CrownSvg from "@/svg/CrownSvg.vue";

export default {
    components: { CrownSvg },

    props: ["presentation"],
};
</script>
